import React, { useState, useContext } from 'react';

import { FieldLabel, StyledTextInput } from 'app/src/elements/inputs';
import Modal from 'app/src/elements/Modal';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import AuthContext from '../../../contexts/AuthContext';

export const Counter = ({
  feeEstimate, setShowModal, createFeeEstimate
}) => {
  const { user } = useContext(AuthContext);
  const [counterAmount, setCounterAmount] = useState('');

  const saveCounter = () => {
    createFeeEstimate(
      {variables:
        {
          status: 'Countered',
          amount: counterAmount,
          type: feeEstimate.type,
          assetId: feeEstimate.asset.id,
          description: feeEstimate.description,
          createdByType: 'User',
          createdById: user.id,
          originalId: feeEstimate.originalId || feeEstimate.id,
          priorId: feeEstimate.priorId || feeEstimate.id,
          activeFor: 'SellerUser'
        }
      }
    );
  };

  return (
    <Modal
      showModal
      setShowModal={setShowModal}
      modalType={feeEstimate.asset.stockNumber}
      objectName={feeEstimate.asset.name}
    >
      <FieldLabel label="Fee Estimate Counter Amount" />
        <StyledTextInput
          onChange={e => setCounterAmount(e.target.value)}
          value={counterAmount || ''}
        />
      <ButtonGroup>
        <Button label="Update" onPress={saveCounter} />
      </ButtonGroup>
    </Modal>
  );
};

export default Counter;
